export const notification = {
    seeAll: true,
    show: false,
};